<app-table
  *ngIf="cols"
  [cols]="cols"
  pageFunctionName="getPaginatedList"
  [service]="shopProductGroupService"
  modelName="Grupos de produtos"
  sortField="id"
  [sortOrder]="-1"
  [defaultRows]="10"
  [changeColumns]="true"
  [addButton]="permission"
  [addLabel]="'Novo grupo'"
  [dropdownFilters]="dropdownFilters"
  addButtonRouterLink="new"
/>
